export const getRibbon = picture => {
  if (picture && picture.primary) {
    return {
      color: 'green',
      content: 'Primary',
      icon: 'star',
      ribbon: true,
    }
  }

  if (picture && picture.report) {
    return {
      color: 'red',
      content: 'QC Picture',
      icon: 'warning sign',
      ribbon: true,
    }
  }
}
